import { render, staticRenderFns } from "./deleteAccountModal.vue?vue&type=template&id=ade3b454&"
import script from "./deleteAccountModal.vue?vue&type=script&lang=ts&"
export * from "./deleteAccountModal.vue?vue&type=script&lang=ts&"
import style0 from "./deleteAccountModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports